
$(function () {

    // ウィンドウの高さを取得
    const window_height = $(window).height();

    // mainの最低高さ設定
    $('main').css({
        'min-height': window_height,
    });

    // Scrollアイコン
    $(document).on("scroll", () => {

        if ($(this).scrollTop() > window_height / 2) {
            // スクロールアイコンを消す
            $('.top_scroll_wrapper').fadeOut();
        }
    });

    // スクロールアイコンクリック
    $(".scroll_icon").on("click", () => {
        $('html, body').animate({ scrollTop: window_height }, 1000, 'swing');
    });
    
});

$(window).on('load', () => {

    // ウィンドウの高さを取得
    const window_height = $(window).height();

    // タイトル表示
    $('.title').css({
        'opacity': '1'
    });

    // 遅延表示
    setTimeout(() => {
        $('.description').css({
            'opacity': '1'
        });
    }, 300);
    setTimeout(() => {
        $('.make_btn_top').css({
            'opacity': '1'
        });
    }, 500);

    // ウィンドウの高さが300以上　の場合のみ
    if (window_height > 300) {
        // 遅延表示
        setTimeout(() => {
            // スクロールしてなかったら
            if ($(document).scrollTop() < window_height) {
                // スクロールアイコン表示
                $('.top_scroll_wrapper').fadeIn();
            }
        }, 3000);
    }
});

$(window).on('load resize', () => {

    // mainの最低高さ
    $('main').css({
        'min-height': $(window).height(),
    });
});

///////////////////////////////////////////////////// TOPスクロール効果
$(function () {
    // ウィンドウの高さを取得
    //window_height = $(window).height();

    // サンプルアルバムがある場合のみ
    /* if (album_uuid != '') {

        $(document).on("scroll", function () {

            if ($(this).scrollTop() > window_height + 100) {
                $('#sample_album_wrapper').css({
                    'position': 'relative',
                    'padding-top': window_height + 100
                });
                $('#index_wrapper').css({
                    'position': 'absolute'
                });
            } else {
                $('#sample_album_wrapper').css({
                    'position': 'fixed',
                    'padding-top': $('.headerSpace').height()
                });
                $('#index_wrapper').css({
                    'position': 'relative'
                });
            }
        });
    } */
});
// IndexWrapperサイズ調整
$(window).on('load resize', function () {

    // ウィンドウの高さを取得
    const window_height = $(window).height();

    // 一旦０に
    // $('#index_wrapper').css({
    //     'height': 0,
    // });

    // $('#index_wrapper').css({
    //     'height': window_height + $('#sample_album_wrapper').height(),
    // });

    if (window_height > 500) {
        $('#index_heroimg').css({
            'height': window_height - $('.headerSpace').height(),
        });
    } else {
        $('#index_heroimg').css({
            'height': 500,
        });
    }
});
